<template>
	<div class="flex h-full" v-if="firstPanel">
		<button
			type="button"
			class="flex-3 mr-1/8 t:mr-1/2 bg-cover bg-center rounded-1/8 t:rounded-1/4 cursor-pointer border-0 min-h-6 t:min-h-12 d:min-h-16"
			aria-label="View Image 1"
			:style="'background-image:url('+firstPanel+')'"
			@click="view(0)">
		</button>
		<div class="flex-1 flex flex-col justify-stretch space-y-1/8 t:space-y-1/2">
			<button
				v-for="(banner, i) in remainingPanels"
				class="flex-1 flex bg-cover bg-center rounded-1/8 t:rounded-1/4 w-full cursor-pointer border-0"
				type="button"
				:aria-label="'View Image '+i"
				:style="'background-image:url('+banner+')'"
				@click="view(i+1)">
			</button>
		</div>

		<mini-carousel :banners="banners" :selected="selected" :index="index" @close="selected = false"></mini-carousel>

	</div>
</template>

<script>
import MiniCarousel from './MiniCarousel.vue';

export default {
	props: ['banners'],
	data() {
		return {
			selected: false,
			index: 0
		}
	},
	components: { MiniCarousel },
	methods: {
		view: function(i) {
			this.index = i;
			this.selected = true;
		}
	},
	computed: {
		firstPanel() {
			return this.banners[0]
		},
		remainingPanels() {
			return this.banners.slice(1,7)
		}

	}
}

</script>

